var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteGalleryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13960",
    "data-name": "Group 13960",
    transform: "translate(-1744 -306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11966",
    "data-name": "Group 11966",
    transform: "translate(1744 306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "delete_24dp_5F6368_FILL1_wght400_GRAD0_opsz24",
    d: "M162.938-822.373a1.885,1.885,0,0,1-1.383-.575,1.885,1.885,0,0,1-.575-1.383v-12.731a.947.947,0,0,1-.7-.281.947.947,0,0,1-.282-.7.947.947,0,0,1,.282-.7.947.947,0,0,1,.7-.281H164.9a.947.947,0,0,1,.282-.7.946.946,0,0,1,.7-.282h3.917a.947.947,0,0,1,.7.282.947.947,0,0,1,.282.7h3.917a.947.947,0,0,1,.7.281.947.947,0,0,1,.282.7.947.947,0,0,1-.282.7.947.947,0,0,1-.7.281v12.731a1.885,1.885,0,0,1-.575,1.383,1.885,1.885,0,0,1-1.383.575Zm2.938-3.917a.948.948,0,0,0,.7-.282.947.947,0,0,0,.282-.7v-6.855a.948.948,0,0,0-.282-.7.948.948,0,0,0-.7-.281.948.948,0,0,0-.7.281.948.948,0,0,0-.282.7v6.855a.947.947,0,0,0,.282.7A.948.948,0,0,0,165.876-826.29Zm3.917,0a.948.948,0,0,0,.7-.282.947.947,0,0,0,.282-.7v-6.855a.948.948,0,0,0-.282-.7.948.948,0,0,0-.7-.281.948.948,0,0,0-.7.281.948.948,0,0,0-.282.7v6.855a.947.947,0,0,0,.282.7A.948.948,0,0,0,169.793-826.29Z",
    transform: "translate(1594.121 1155.143)",
    fill: "#111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteGalleryIcon);
export default __webpack_public_path__ + "static/media/delete_gallery_icon.19d6228126f33ff4644eb98d96ec7b83.svg";
export { ForwardRef as ReactComponent };